import { createNamespacedHelpers } from 'vuex-composition-helpers';
import { computed } from '@vue/composition-api';
const { useState } = createNamespacedHelpers('ui');
export const useMobileView = () => {
    const { mobileView } = useState(['mobileView']);
    const isMobileView = computed(() => mobileView.value.active);
    return { isMobileView };
};
